import { Component, type ErrorInfo, type ReactNode } from "react";
import * as Sentry from "@sentry/react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-full flex-col items-center justify-center bg-ide-dark p-8 text-center text-ide-offwhite">
          <h1 className="font-heading text-xl font-bold">Something went wrong</h1>
          <p className="mt-2 max-w-md text-sm text-ide-offwhite/70">{this.state.error.message}</p>
          <button
            type="button"
            className="ide-btn ide-btn-primary mt-4"
            onClick={() => window.location.assign("/")}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
